const NavbarLinks = ({href,label,onClick,active}) => {
  return (
      <li>
        <a href={href} className={active ? 'active' : ''} onClick={onClick}>{label}</a>
      </li>
  )
}

export default NavbarLinks
